import { TransitionTypeFinder } from './TransitionTypeFinder';
import { TransitionType } from '../../utils/types';

export class StaticTransitionTypeFinder implements TransitionTypeFinder {
    private transitionType: TransitionType;

    constructor(view: TransitionType) {
        this.transitionType = view;

        this.update();
    }

    get = (): TransitionType => {
        return this.transitionType;
    }

    update(): void {}
}


// WEBPACK FOOTER //
// ./src/webportal/services/transitionType/StaticTransitionTypeFinder.ts